'use strict';

module.exports = function () {
    var searchModalTimer = null;
    var endpoint = $('.search-modal-suggestions-wrapper').data('url');
    var previousActiveElement = null; // Store element that opened modal

    /**
     * Highlight search terms in suggestion text (only text content, not attributes)
     * @param {string} searchTerm - Search query term to highlight
     * @param {jQuery} $container - Container element containing suggestions
     */
    function highlightSearchTerms(searchTerm, $container) {
        if (!searchTerm || searchTerm.length < 3) {
            return;
        }

        var regex = new RegExp('(' + searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
        var selector = '.suggestions .name, .suggestions .item.term a, .suggestions .link .name, .suggestions .product-info .name, .suggestions .category-parent';

        $container.find(selector).each(function () {
            var $element = $(this);
            if ($element.find('.search-highlight').length > 0) {
                return; // Already highlighted
            }

            /**
             * Process text nodes recursively to highlight search terms
             * @param {Node} node - DOM node to process
             */
            function processTextNodes(node) {
                if (node.nodeType === 3) { // Text node
                    var text = node.textContent;
                    if (regex.test(text)) {
                        var highlighted = text.replace(regex, '<mark class="search-highlight">$1</mark>');
                        $(node).replaceWith(highlighted);
                    }
                } else {
                    $(node).contents().each(function () {
                        processTextNodes(this);
                    });
                }
            }

            processTextNodes(this);
        });
    }

    /**
     * Load search suggestions via AJAX
     * @param {string} searchTerm - Search query term
     */
    function loadSuggestions(searchTerm) {
        var $wrapper = $('.search-modal-suggestions-wrapper');
        var $modal = $('#searchModal');
        var $skeleton = $wrapper.find('.search-modal-skeleton');
        var minCharsForSuggestions = 3;
        var searchQuery = searchTerm || '';

        // Only make AJAX call if:
        // 1. Search term is empty (show recent/popular)
        // 2. Search term has 3+ characters (show typed suggestions)
        // Don't call for 1-2 characters
        if (searchQuery.length > 0 && searchQuery.length < minCharsForSuggestions) {
            // Clear suggestions if user has typed 1-2 characters
            $skeleton.addClass('d-none');
            $wrapper.find('.suggestions').remove();
            $wrapper.hide();
            return;
        }

        // Clear previous timer
        clearTimeout(searchModalTimer);

        searchModalTimer = setTimeout(function () {
            if (endpoint && $modal.hasClass('show')) {
                // Store skeleton HTML before replacing (it's in template)
                var skeletonHTML = $skeleton.length ? $skeleton[0].outerHTML : '';

                // Show skeleton placeholder instead of spinner
                $wrapper.show();
                $skeleton.removeClass('d-none');
                $wrapper.find('.suggestions').remove();

                $.ajax({
                    url: endpoint + encodeURIComponent(searchQuery),
                    method: 'GET',
                    success: function (response) {
                        if (typeof response === 'string' && response.trim()) {
                            // Replace wrapper content with suggestions and restore skeleton
                            $wrapper.html(response + skeletonHTML);
                            // Highlight search terms in suggestions
                            if (searchQuery && searchQuery.length >= minCharsForSuggestions) {
                                highlightSearchTerms(searchQuery, $wrapper);
                            }
                            $wrapper.show();
                        } else {
                            // No content: clear suggestions but keep skeleton visible
                            $wrapper.find('.suggestions').remove();
                            // $wrapper.find('.search-modal-skeleton').removeClass('d-none');
                            $wrapper.show();
                        }
                        $wrapper.find('.search-modal-skeleton').addClass('d-none');
                    },
                    error: function () {
                        // On error: clear everything, don't restore skeleton
                        $wrapper.empty().hide();
                    }
                });
            }
        }, 300); // 300ms debounce
    }

    /**
     * Trap focus inside modal
     * @param {KeyboardEvent} e - Keyboard event
     * @param {jQuery} $modal - Modal jQuery object
     */
    function trapFocus(e, $modal) {
        var selector = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
        var $focusable = $modal.find(selector).filter(':visible').not('.d-none');
        if ($focusable.length === 0) return;

        var $first = $focusable.first();
        var $last = $focusable.last();
        var $active = $(document.activeElement);

        if (e.shiftKey && $active.is($first)) {
            e.preventDefault();
            $last.focus();
        } else if (!e.shiftKey && $active.is($last)) {
            e.preventDefault();
            $first.focus();
        } else if (!$modal.find($active).length) {
            e.preventDefault();
            $first.focus();
        }
    }

    /**
     * Helper function to open search modal
     */
    function openSearchModal() {
        var $modal = $('#searchModal');
        previousActiveElement = document.activeElement;
        $modal.addClass('show');
        $('body').addClass('search-modal-open');
        $modal.find('.search-modal-input').focus();

        setTimeout(function () {
            // Don't clear wrapper on open - skeleton is already there
            loadSuggestions('');
        }, 100);
    }

    /**
     * Helper function to close search modal
     */
    function closeSearchModal() {
        var $modal = $('#searchModal');
        $modal.removeClass('show').addClass('closing');
        $('body').removeClass('search-modal-open');
        $modal.find('.search-modal-input').val('');
        var $wrapper = $('.search-modal-suggestions-wrapper');
        // Clear suggestions but keep skeleton (it's in template)
        $wrapper.find('.suggestions').remove();
        $wrapper.find('.search-modal-skeleton').addClass('d-none');
        $('.search-modal-clear-btn').addClass('d-none');

        if (previousActiveElement && $(previousActiveElement).length) {
            setTimeout(function () {
                $(previousActiveElement).focus();
            }, 100);
        }
        previousActiveElement = null;

        setTimeout(function () {
            $modal.removeClass('closing');
        }, 300);
    }

    // Open search modal when clicking search icon
    $('.search-icon a').on('click', function (e) {
        e.preventDefault();
        openSearchModal();
    });

    // Close modal when clicking close button (both top and search bar)
    $('body').on('click', '.search-modal-close, .search-modal-close-btn', function () {
        closeSearchModal();
    });

    // Close modal when clicking overlay
    $('body').on('click', '.search-modal-overlay', function () {
        closeSearchModal();
    });

    // Prevent modal content clicks from closing modal
    $('body').on('click', '.search-modal-content', function (e) {
        e.stopPropagation();
    });

    // Trap focus and handle Escape key
    $(document).on('keydown', function (e) {
        var $modal = $('#searchModal');
        if (!$modal.hasClass('show')) return;

        if (e.key === 'Tab') {
            trapFocus(e, $modal);
        } else if (e.key === 'Escape') {
            closeSearchModal();
        }
    });

    // Handle search input - load suggestions as user types
    $('body').on('keyup input', '#searchModal .search-modal-input', function () {
        var $input = $(this);
        var $clearBtn = $('.search-modal-clear-btn');
        var searchTerm = $input.val();

        // Toggle clear button visibility
        $clearBtn.toggleClass('d-none', searchTerm.length === 0);

        loadSuggestions(searchTerm);
    });

    // Handle clear button click
    $('body').on('click', '.search-modal-clear-btn', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $input = $('#searchModal .search-modal-input');
        $input.val('').focus();
        $('.search-modal-clear-btn').addClass('d-none');
        loadSuggestions('');
    });
};

